import { SchoolInformationActions } from ".";

let initialState = {
    saveSchoolInformationInProcess: false,
    getSchoolInformationInProgress: false,
    deleteSchoolInformationInProgress: false,
    updateSchoolinformationInProgress: false,
    user: [],
    schoolList: [],
    activeSchool: {},
    newList: [],
    schoolsSummary: [],
    activeScheduleIndex: 0, activeScheduleId: null,
    verifyTimeTableInProgress: false,
    verifyTimeTableInComplete: false,
    verifyTimeTableInFailed: false,
    generateTimeTableInProgress: false,
    generateTimeTableInComplete: false,
    generateTimeTableInFailed: false,
}



const createSchoolInformationReducer = (state = initialState, action) => {
    switch (action.type) {
        case SchoolInformationActions.SCHOOLINFORMATION_IN_PROCESS:
            return { ...state, saveSchoolInformationInProcess: true };
        case SchoolInformationActions.SCHOOLINFORMATION_COMPLETE:
            return { ...state, saveSchoolInformationInProcess: false, activeSchool: action.data };
        case SchoolInformationActions.STORE_USER_COMPLETE:
            return { ...state, SchoolInformationInProcess: false, stored: action.data };
        case SchoolInformationActions.RETRIEVE_SCHOOLIFORMATION_IN_PROGRESS:
            return { ...state, getSchoolInformationInProgress: true };
        case SchoolInformationActions.RETRIEVE_SCHOOLIFORMATION_COMPLETE:
            let tempArray = [];
            tempArray = tempArray.concat(action.data)
            return { ...state, getSchoolInformationInProgress: false, schoolList: tempArray }

        case SchoolInformationActions.SET_ACTIVE_SCHOOL:

            let activeSchool = action.data;
            let newState = { ...state, activeSchool: activeSchool }
            return newState
        case SchoolInformationActions.SET_IS_CREATE_NEW_SCHOOL:
            return { ...state, isCreateNewSchool: action.data }

        case SchoolInformationActions.SCHOOLINFORMATION_DELETION_IN_PROGRESS:
            return { ...state, deleteSchoolInformation: true };

        case SchoolInformationActions.SCHOOLINFORMATION_DELETION_COMPLETE:
            let tempData = [];
            tempData = tempData.concat(action.data)
            return { ...state, deleteSchoolInformation: false, schoolList: action.schoolList };
        case SchoolInformationActions.SCHOOL_INFORMATION_UPDATE_IN_PROGRESS:
            return { ...state, updateSchoolinformationInProgress: true }
        case SchoolInformationActions.SCHOOL_INFORMATION_UPDATE_COMPLETE:
            return { ...state, updateSchoolinformationInProgress: false, activeSchool: action.school }
        case SchoolInformationActions.RETRIEVE_SCHOOLS_SUMMARY_IN_PROGRESS:
            return { ...state, getSchoolsSummaryInProgress: true }
        case SchoolInformationActions.RETRIEVE_SCHOOLS_SUMMARY_COMPLETE:
            return { ...state, getSchoolsSummaryInProgress: false, schoolsSummary: action.data }
        case SchoolInformationActions.GET_SCHOOL_INFORMATION_BY_ID_IN_PROGRESS:
            return { ...state, getSchoolInformationByIdInProgress: true };
        case SchoolInformationActions.GET_SCHOOL_INFORMATION_BY_ID_COMPLETE:
            return { ...state, getSchoolInformationByIdInProgress: false, activeSchool: action.data };
        case SchoolInformationActions.VERIFY_TIMETABLE_BY_SCHOOL_ID_IN_PROGRESS:
            return { ...state, verifyTimeTableInProgress: true, verifyTimeTableInFailed: false, verifyTimeTableInComplete: false };
        case SchoolInformationActions.VERIFY_TIMETABLE_BY_SCHOOL_ID_COMPLETE:
            return { ...state, verifyTimeTableInProgress: false, verifyTimeTableInComplete: true, activeSchool: action.data };
        case SchoolInformationActions.VERIFY_TIMETABLE_BY_SCHOOL_ID_FAILED:
            return { ...state, verifyTimeTableInProgress: false, verifyTimeTableInFailed: true };
        case SchoolInformationActions.GENERATE_TIMETABLE_BY_SCHOOL_ID_IN_PROGRESS:
            return { ...state, generateTimeTableInProgress: true, generateTimeTableInFailed: false, generateTimeTableInComplete: false };
        case SchoolInformationActions.GENERATE_TIMETABLE_BY_SCHOOL_ID_COMPLETE:
            return { ...state, generateTimeTableInProgress: false, generateTimeTableInComplete: true, activeSchool: action.data };
        case SchoolInformationActions.GENERATE_TIMETABLE_BY_SCHOOL_ID_FAILED:
            return { ...state, generateTimeTableInProgress: false, generateTimeTableInFailed: true };
        case "TEST":

            return { ...state, test: "test" }
        case SchoolInformationActions.SET_ACTIVE_SCHEDULE:
            let activeScheduleIndex = action.data.index;
            return { ...state, activeScheduleIndex: activeScheduleIndex, activeScheduleId: action.data.id }
        case SchoolInformationActions.UPDATE_SCHOOL_SCHEDULE_CONSTRAINTS_COMPLETE:
            
            return { ...state, updateSchoolinformationInProgress: false, activeSchool: action.data }
        case SchoolInformationActions.DELETE_SCHOOL_IN_PROGRESS:
            return { ...state, deleteSchoolInformationInProgress: true }
        case SchoolInformationActions.DELETE_SCHOOL_COMPLETE:
            return { ...state, deleteSchoolInformationInProgress: false }
        default:
            return state;
    }


}
export default createSchoolInformationReducer;